import { arrayToBase64, derivePasswordKey, generateAesGcmKey, generateRandomSalt, } from '@lucidlink/ts-crypto/crypto';
import { generateScramRecord, SCRAM_ITERATION_COUNT, } from '@lucidlink/ts-crypto/scram';
import { webCrypto } from '@lucidlink/ts-crypto/web-crypto';
import { AccountCrypto } from './account-crypto';
export const wrapKeyWithPassword = async (password, cryptoKey) => {
    const cryptoSalt = generateRandomSalt();
    const passwordKey = await derivePasswordKey(password, SCRAM_ITERATION_COUNT, cryptoSalt);
    const wrappedCryptoKey = await webCrypto.subtle.wrapKey('raw', cryptoKey, passwordKey, { name: 'AES-KW' });
    const encodedCryptoKey = arrayToBase64(wrappedCryptoKey);
    return {
        wrappedCryptoKeyB64: encodedCryptoKey,
        salt: cryptoSalt,
        iterations: SCRAM_ITERATION_COUNT,
    };
};
const encryptAccountKeyWithPassword = async (password, accountCryptoParams) => {
    const accountCrypto = new AccountCrypto(accountCryptoParams);
    const accountKey = await accountCrypto.getAccountKey();
    return await wrapKeyWithPassword(password, accountKey);
};
export const deriveUserIdentity = async (password, accountCryptoParams) => {
    const userCryptoParams = encryptAccountKeyWithPassword(password, accountCryptoParams);
    const scramRecordPromise = generateScramRecord(password);
    const [userCrypto, scramRecord] = await Promise.all([
        userCryptoParams,
        scramRecordPromise,
    ]);
    return {
        scramIterations: scramRecord.iterations,
        scramSalt: scramRecord.salt,
        scramStoredKey: scramRecord.storedKey,
        userCryptoKey: userCrypto.wrappedCryptoKeyB64,
        userCryptoKeySalt: userCrypto.salt,
        userCryptoKeyIterations: userCrypto.iterations,
    };
};
export const prepareNewUserIdentity = async (password) => {
    const newAccountKey = await generateAesGcmKey();
    const userCryptoParams = wrapKeyWithPassword(password, newAccountKey);
    const scramRecordPromise = generateScramRecord(password);
    const [userCrypto, scramRecord] = await Promise.all([
        userCryptoParams,
        scramRecordPromise,
    ]);
    return {
        scramIterations: scramRecord.iterations,
        scramSalt: scramRecord.salt,
        scramStoredKey: scramRecord.storedKey,
        userCryptoKey: userCrypto.wrappedCryptoKeyB64,
        userCryptoKeySalt: userCrypto.salt,
        userCryptoKeyIterations: userCrypto.iterations,
    };
};
